/* ============
 * Getters for the assessment module
 * ============
 *
 * The getters that are available on the
 * assessment module.
 */
import {
  clone
} from '@/utils/object';

const getAssessments = state => clone(state.assessments);
const getTotalCount = state => clone(state.totalCount);
const getIsLoading = state => state.assessmentLoading;
const getAssessmentSymptoms = state => clone(state.assessmentSymptoms);

export default {
  getAssessments,
  getTotalCount,
  getIsLoading,
  getAssessmentSymptoms
};
